import AxioClient from "@/repositories/Clients/AxioClient";
const resource = '/orders';

export default {
    getAll() {
        return AxioClient.get(`${resource}`);
    },
    get(id) {
        return AxioClient.get(`${resource}/${id}`);
    },
    saveTickets(payload, id) {
        return AxioClient.post(`${resource}/tickets/${id}`, payload)
    },
    shipTickets(id) {
        return AxioClient.post(`${resource}/shipped/${id}`)
    },
    create(payload) {
        return AxioClient.post(`${resource}`, payload);
    },
    update(payload, id) {
        return AxioClient.put(`${resource}/${id}`, payload);
    },
    delete(id) {
        return AxioClient.delete(`${resource}/${id}`)
    },

    // MANY OTHER ENDPOINT RELATED STUFFS
};